define('drops/drawings/flow/flow',['jquery', 'drops/drawings/businessprocessElement', 'drops/drawings/businessprocessEvents', 'drops/drawings/flow/segment'],
    function ($, BusinessProcessElement, businessProcessEvents, Segment) {
        'use strict';

        var defaults = {
            data: {
                outId: null,
                inId: null,
                size: { x: 100, y: 100 },
                text: "",
                textTop: -10,
                textLeft: 10,
                joints: [],
                linkToApplication: false
            }
        };

        function Flow(options) {
            BusinessProcessElement.call(this, $('<div/>'), defaults, options);
            var self = this;

            self.outDrop = null;
            self.inDrop = null;

            self.$element.addClass('bp-flow-root');

            self.createAllSegments();

            self.listenToConnectedDropMovements();
        };

        BusinessProcessElement.extend(Flow, BusinessProcessElement);

        Flow.typeName = 'Flow';

        Flow.prototype.applyPosition = $.noop;

        Flow.prototype.acceptsFlowConnections = false;

        Flow.prototype.createSegment = function () {
            return new Segment();
        };

        Flow.prototype.createAllSegments = function () {
            var self = this;
            self.segments = [];
            self.segments.push(self.createSegment());
            _.forEach(self.data.joints, function () {
                self.segments.push(self.createSegment());
            });
            self.segments.pop();
            self.segments.push(self.createSegment());

            _.forEach(self.segments, function (segment) {
                self.$element.prepend(segment.$element);
            });
        };

        Flow.prototype.listenToConnectedDropMovements = function () {
            var self = this;

            if (self.data.outId != null) {
                businessProcessEvents.removeListener('bp_element_moved_' + self.data.outId, self);
                businessProcessEvents.addListener('bp_element_moved_' + self.data.outId, function (bpElement) {
                    self.outDrop = bpElement;

                    self.data.position = bpElement.getAnchoringPoints()[0];
                    self.drawSegments();
                }, self);
            }

            if (self.data.inId != null) {
                businessProcessEvents.removeListener('bp_element_moved_' + self.data.inId, self);
                businessProcessEvents.addListener('bp_element_moved_' + self.data.inId, function (bpElement) {
                    self.inDrop = bpElement;

                    self.data.size = bpElement.getAnchoringPoints()[0];
                    self.drawSegments();
                }, self);
            }
        };

        Flow.prototype.drawSegments = function () {
            var self = this;
            var points = self.getAllSegmentCoordinates();
            for (var i = 0; i < self.segments.length; i++) {
                self.segments[i].startPoint = points[i][0];
                self.segments[i].endPoint = points[i][1];
                self.segments[i].draw();
            }

            if (self.segments.length !== 0) {
                self.segments[0].showText(self.data.text);
                self.segments[0].setTextPosition({ x: self.data.textLeft, y: self.data.textTop });
                self.segments[self.segments.length - 1].showArrow();
            }
        };

        Flow.prototype.getAllSegmentCoordinates = function () {
            var self = this;

            var getAvailablePoints = function (bpElement, fallback) {
                if (bpElement != null) {
                    return bpElement.getAnchoringPoints();
                }
                return [fallback];
            };

            var pointGroups = [];
            pointGroups.push(getAvailablePoints(this.outDrop, this.data.position));
            _.forEach(self.data.joints, function (jointPoint) {
                pointGroups.push([jointPoint]);
            });
            pointGroups.push(getAvailablePoints(this.inDrop, this.data.size));

            var points = [];
            for (var i = 0; i < (pointGroups.length - 1) ; i++) {
                points.push(self.getClosestPoints(pointGroups[i], pointGroups[i + 1]));
            }

            return points;
        };

        Flow.prototype.getClosestPoints = function (pointGroupA, pointGroupB) {
            var getDistanceBetweenPoints = function (pointA, pointB) {
                return Math.sqrt(Math.pow(pointB.x - pointA.x, 2) + Math.pow(pointB.y - pointA.y, 2));
            };

            var shortestDistance = null;
            var closestAnchoringPoints = [];

            _.each(pointGroupA, function (outPoint) {
                _.each(pointGroupB, function (inPoint) {
                    var distance = getDistanceBetweenPoints(outPoint, inPoint);
                    if (shortestDistance === null || shortestDistance > distance) {
                        shortestDistance = distance;
                        closestAnchoringPoints = [outPoint, inPoint];
                    }
                });
            });

            return closestAnchoringPoints;
        };

        Flow.prototype.preRender = function () {
            this.drawSegments();
        };

        return Flow;
    });
